import { useSearchParams } from 'external/react';
import useAdmin from 'context/admin-context/hook';

const statusColor = (status: string) => status === 'active' ? '#28a745' : '#dc3545';

const PurchaseTabs = () => {
  const { state } = useAdmin();
  const purchases = state.client.purchases.items;
  const [searchParams, setSearchParams] = useSearchParams();
  const selected = Math.min(Number(searchParams.get('purchaseIndex') ?? 0), purchases.length - 1);

  const handleSelect = (index: number) => {
    setSearchParams(prev => { prev.set('purchaseIndex', String(index)); return prev; }, { replace: true });
  };

  const formatDate = (dateStr: string) =>
    new Date(dateStr).toLocaleDateString('es-PR', { year: 'numeric', month: 'short', day: 'numeric' });

  if (purchases.length === 0) return null;

  // Dropdown mode for 5+ packages
  if (purchases.length >= 5) {
    return (
      <div className="d-flex align-items-center gap-2">
        <select
          className="form-select form-select-sm"
          style={{ maxWidth: 320 }}
          value={selected}
          onChange={e => handleSelect(Number(e.target.value))}
        >
          {purchases.map((p, i) => (
            <option key={p.id} value={i}>
              {p.planAlias} — {formatDate(p.purchaseDate)}
            </option>
          ))}
        </select>
        <span
          style={{
            width: 10, height: 10, borderRadius: '50%',
            backgroundColor: statusColor(purchases[selected].subscriptionStatus),
            display: 'inline-block', flexShrink: 0
          }}
        />
      </div>
    );
  }

  // Tab mode for less than 5 packages
  return (
    <ul className="nav nav-tabs">
      {purchases.map((p, i) => (
        <li key={p.id} className="nav-item">
          <button
            className={`nav-link d-flex align-items-center gap-2 ${i === selected ? 'active' : ''}`}
            onClick={() => handleSelect(i)}
          >
            <span
              style={{
                width: 8, height: 8, borderRadius: '50%',
                backgroundColor: statusColor(p.subscriptionStatus),
                display: 'inline-block', flexShrink: 0
              }}
            />
            <span className="d-flex flex-column align-items-start">
              <span>{p.planAlias}</span>
              <span className="text-muted" style={{ fontSize: '0.7rem' }}>
                {formatDate(p.purchaseDate)}
              </span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default PurchaseTabs;